import { authHeader, isTokenExpired } from "../helpers";

export const campaignService = {
  fetchCampaigns,
  fetchCampaignList,
  fetchCampaignParticipants,
  deleteParticipant,
};

function fetchCampaignList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/campaign`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchCampaigns(offset = -1, limit = -1) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url =
    offset >= 0 && limit > 0
      ? `${process.env.REACT_APP_GATEWAY_URL}/admin/campaigns/active?offset=${offset}&limit=${limit}`
      : `${process.env.REACT_APP_GATEWAY_URL}/admin/campaigns/active`;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchCampaignParticipants(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/campaigns/${id}/usercampaigns`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteParticipant(id, idParticipant, toastError, toastSuccess) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/campaigns/${id}/usercampaigns/${idParticipant}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        toastSuccess();
        return res.text();
      } else {
        toastError();
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
